import { ColorSAP } from "../../ontego-ui";
import { styled } from '@mui/material';

const Styled = {};

Styled.FunctionCardCollectionContainer = styled("div")(({ isActive, isDragging }) => ({
    position: 'relative',
    cursor: 'pointer',
    boxSizing: "border-box",
    padding: 16,
    borderRadius: 18,
    border: isDragging ? `2px solid ${ColorSAP.primary[80]}` : `2px solid ${ColorSAP.primary[70]}`,
    transition: "all .15s ease-in-out",
    backgroundColor: isDragging ? ColorSAP.primary[80] : isActive ? ColorSAP.primary[70] : ColorSAP.neutral[0],
    color: `${ColorSAP.neutral[0]} !important`,

    "& svg:not(.editor-icon)": (isDragging || isActive) ? {
        color: `${ColorSAP.neutral[0]} !important`
    } : {},

    "&:hover": isActive ? {} : {
        backgroundColor: ColorSAP.primary[70],
        color: `${ColorSAP.neutral[0]} !important`,
        "& .functionCardCollectionTextIcon svg": {
            color: ColorSAP.neutral[0],
        },
        "& .container__primary svg": {
            color: ColorSAP.neutral[0],
        }
    },
    "& .functionCardCollectionTextIcon svg": isActive ? {
        color: ColorSAP.neutral[0],
    } : {},
    "& .container__primary svg": isActive ? {
        color: ColorSAP.neutral[0],
    } : {}
}));

Styled.FunctionCardCollectionTextIconContainer = styled("div")(() => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    paddingBottom: 6,
    "& svg": {
        width: 24,
        height: 24,
        color: ColorSAP.primary[100],
    }
}));

Styled.FunctionCollectionChipContainer = styled("div")(() => ({
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 10,
}));

Styled.FunctionCardCollectionTextIcon = styled("div")(() => ({
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%',
    marginTop: 12,
    "& svg": {
        width: 32,
        height: 32,
        marginRight: 6,
        color: ColorSAP.primary[70],
    }
}));

export default Styled;
